<template>
  <div class="addEditBrandIncreasePage">
    <div class="form_wrap">
      <div class="block">
        <h1>供应商名称</h1>
        <div class="input_box">
          <van-field
            v-model="params.labelname"
            placeholder="请输入供应商名称"
          />
        </div>
      </div>
      <!-- <div class="block">
        <h1>标签内容</h1>
        <div class="input_box">
          <van-field v-model="params.labelname" placeholder="请输入标签内容" />
        </div>
      </div> -->
      <!-- <div class="block">
        <h1>排序</h1>
        <div class="input_box">
          <van-field v-model.number="params.sort" placeholder="请输入排序" />
        </div>
      </div> -->
      <!-- <div class="block">
        <h1>HTML链接</h1>
        <div class="input_box">
          <van-field
            v-model.number="params.linkurl"
            placeholder="请输入HTML链接"
          />
        </div>
      </div>
      <div class="block">
        <h1>小程序路径</h1>
        <div class="input_box">
          <van-field
            v-model.number="params.apppath"
            placeholder="请输入小程序路径"
          />
        </div>
      </div> -->
      <div class="state">
        <h1>供应商状态</h1>
        <van-radio-group
          v-model="params.labelstate"
          class="flex-around state_radio"
        >
          <van-radio name="1" checked-color="#ee0a24">启用</van-radio>
          <van-radio
            name="0"
            :disabled="id != '' ? true : false"
            checked-color="#ee0a24"
            >停用</van-radio
          >
        </van-radio-group>
      </div>

      <div class="primary-button" @click="handleSubmit">保存确认</div>
      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回
      </div>
    </div>
  </div>
</template>
  
  <script>
import {
  getSupplierDetail,
  addSupplier,
  editSupplier,
  encryptstringview,
} from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "supplierDetail",
  data() {
    return {
      params: {
        openid: "",
        qyid: "",
        labelname: "",
        labelcont: "",
        sort: "",
        labelstate: "1",
        linkurl: "",
        apppath: "",
        createman: "",
      },
      id: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.params.qyid = USERINFO.qy.id;
    } else {
      this.qyid = 0;
    }
    this.params.createman = USERINFO.truename
      ? USERINFO.truename
      : USERINFO.nickname;
    this.params.openid = USERINFO.openid;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        if (id) {
          this.id = id;
          this.init(id);
        }
      } else {
        this.$router.back();
      }
    },

    // 初始化数据
    init(id) {
      getSupplierDetail({ id }).then((res) => {
        this.params.labelname = res.labelname;
        this.params.labelcont = res.labelcont;
        this.params.sort = res.sort ? res.sort : "";
        this.params.labelstate = res.labelstate ? res.labelstate : 0;
        this.params.linkurl = res.linkurl;
        this.params.apppath = res.apppath;
      });
    },

    // 提交编辑数据
    handleSubmit() {
      let { params, id } = this;
      if (params.labelname == "") {
        this.$toast("请输入供应商名称");
        return;
      }
      // if (params.labelcont == "") {
      //   this.$toast("请输入标签内容");
      //   return;
      // }
      if (params.labelstate == "") {
        this.$toast("请选择供应商状态");
        return;
      }
      params.labelcont = params.labelname;
      if (id == "") {
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        addSupplier(params).then((res) => {
          Toast.clear();
          if (res.result) {
            this.$toast.success(res.message);
            setTimeout(() => {
              // this.clearData();
              this.handleReturn();
            }, 1000);
          } else {
            this.$toast.fail(res.message);
            this.clearData();
          }
        });
      } else {
        params.id = id;
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        editSupplier(params).then((res) => {
          Toast.clear();
          if (res.result) {
            this.$toast.success(res.message);
            setTimeout(() => {
              this.handleReturn();
            }, 2000);
          } else {
            this.$toast.fail(res.message);
          }
        });
      }
    },

    // 清空
    clearData() {
      this.params.labelname = "";
      this.params.labelcont = "";
      this.params.sort = "";
      this.params.labelstate = "";
      this.params.linkurl = "";
      this.params.apppath = "";
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
  <style lang="less" scoped>
.addEditBrandIncreasePage {
  .upload_img {
    width: 100%;
    height: 750px;
    background: #e4e4e4;
    position: relative;
    /deep/ .van-uploader {
      width: 100%;
      height: 100%;
    }
    /deep/ .van-uploader__wrapper {
      width: 100%;
      height: 100%;
    }
    /deep/ .van-uploader__input-wrapper {
      width: 100%;
    }
    .box {
      flex-flow: column;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      img {
        width: 176px;
      }
      p {
        font-size: 30px;
        color: #515151;
        text-align: center;
        margin-top: 60px;
      }
    }
    .block {
      height: 100%;
      overflow: hidden;
      img {
        height: 100%;
      }
    }
    .del {
      position: absolute;
      background: rgba(246, 37, 96, 0.8);
      height: 70px;
      bottom: 0;
      left: 0;
      right: 0;
      font-size: 44px;
      color: #fff;
      text-align: center;
      line-height: 70px;
      span {
        font-size: 26px;
        margin-left: 10px;
      }
    }
  }
  .form_wrap {
    padding: 116px 75px 340px;
    .block {
      margin-bottom: 55px;
    }
    h1 {
      font-size: 30px;
      color: #444444;
      margin-bottom: 35px;
      text-align: center;
      font-weight: 400;
    }
    .input_box {
      margin-bottom: 30px;
    }
    .state {
      margin: 160px auto;
      /deep/ .van-radio__label {
        font-size: 14px;
      }
    }
  }
}
</style>